import { useState } from 'react';
import SortButton from './SortButton';
import SortModal from './SortModal';
import { useTranslation } from 'react-i18next';
import { buttonStyles } from '../../styles/commonStyles';

function SortControls({ sortOption, setSortOption }) {
    const { t } = useTranslation();
    const [isSortModalOpen, setIsSortModalOpen] = useState(false);

    const SORT_OPTIONS = {
        popular: t('sortControls.popular'),
        popular24h: t('sortControls.popular24h'),
        newest: t('sortControls.newest'),
        newest24h: t('sortControls.newest24h'),
    };

    const toggleSortModal = () => setIsSortModalOpen((prev) => !prev);

    return (
        <div className="absolute top-[6px] right-[8px] z-40 py-1 w-full">
            <div className="w-full flex justify-end pr-4">
                <SortButton
                    sortOption={sortOption}
                    onClick={toggleSortModal}
                    options={SORT_OPTIONS}
                    className={buttonStyles}
                />
            </div>
            <SortModal
                isOpen={isSortModalOpen}
                onClose={toggleSortModal}
                onSelect={setSortOption}
                selectedOption={sortOption}
                options={SORT_OPTIONS}
            />
        </div>
    );
}

export default SortControls;
